<template>
  <div>
    <el-dialog
        title="设置导购名字关键字"
        :visible.sync="guiderAliasFlag"
        width="800px"
        :show-close="false"
        :close-on-click-modal="false"
    >
      <div class="title-ms">配置的关键字等同该导购姓名，姓名变更后关键字失效</div>
      <el-form
          class="mt20"
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="130px">
        <el-form-item label="导购姓名" prop="guiderName">
          {{ ruleForm.guiderName }}
        </el-form-item>
        <el-form-item label="姓名关键字" prop="aliasList">
          <el-tag
              :key="tag"
              v-for="tag in ruleForm.aliasList"
              closable
              :disable-transitions="false"
              @close="handleCloseLast(tag)"
          >{{ tag }}</el-tag
          >
          <el-input
              class="input-new-tag"
              v-if="inputVisibleAlias"
              v-model.trim="inputValueAlias"
              ref="saveTagInputAlias"
              size="small"
              maxlength="10"
              clearable
              placeholder="请输入关键字，在10个汉字以内"
              @keyup.enter.native="handleInputConfirmAlias"
              @blur="handleInputConfirmAlias"
          ></el-input>
          <el-button
              v-else
              class="button-new-tag"
              size="small"
              @click="showInputAlias"
          >+ 关键字</el-button
          >
          <span class="form-red">不输入则不限制</span>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer flex flex-center mt20">
        <el-button @click="confirmAliasList" size="small" type="primary">
          确 定</el-button
        >
        <el-button @click="closeDiaLog" size="small" >
          取 消</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {unique} from "@/utils/utils";

export default {
  props: {
    guiderAliasFlag: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      inputVisibleAlias: false,
      inputValueAlias: "",
      rules: {},
      ruleForm: {
        aliasList: [],
        guiderName: "",
        guiderId: "",
      }
    };
  },
  created() {},
  mounted() {},
  methods: {
    async confirmAliasList() {
      let params = JSON.parse(JSON.stringify(this.ruleForm));
      if (params.aliasList && params.aliasList.length > 0) {
        params.aliasName = params.aliasList.join(",");
      }
      await this.$store.dispatch("editGuiderAliasName", params);
      this.$emit("getGuiderAliasName", params.aliasName);
      this.$message({
        message: "操作成功！",
        type: "success"
      });
      this.closeDiaLog();
    },
    initList(data) {
      this.ruleForm = data;
    },
    handleCloseLast(tag) {
      this.ruleForm.aliasList.splice(
          this.ruleForm.aliasList.indexOf(tag),
          1
      );
    },
    handleInputConfirmAlias() {
      let inputValue = this.inputValueAlias;
      if (inputValue) {
        this.ruleForm.aliasList.push(inputValue);
        this.ruleForm.aliasList = unique(this.ruleForm.aliasList);
      }
      this.inputVisibleAlias = false;
      this.inputValueAlias = "";
    },
    showInputAlias() {
      this.inputVisibleAlias = true;
      this.$nextTick(() => {
        this.$refs.saveTagInputAlias.$refs.input.focus();
      });
    },
    closeDiaLog() {
      this.$emit('update:guiderAliasFlag', false)
    }
  },
};
</script>

<style scoped lang="scss">
.title-ms {
  color: #999999;
}
</style>
